import { FC, PropsWithChildren } from "react";

const Layout: FC<PropsWithChildren<any>> = ({ children }) => {
    return <>{children}</>;
};

export default Layout;
